import React, { useEffect, useState, useRef } from "react";
import { Box, Text, VStack, useColorModeValue } from "@chakra-ui/react";

export function RecollectionGraphFrame() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const isEnabled =
    process.env.REACT_APP_LEXI_RECOLLECTION_GRAPH_ENABLED === "true" ||
    process.env.REACT_APP_LEXI_RECOLLECTION_GRAPH_ENABLED === "1";

  const embedUrl = process.env.REACT_APP_REAGRAPH_EMBED_URL || "http://127.0.0.1:19090/embed";

  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("pink.100", "pink.900");

  useEffect(() => {
    if (!isEnabled) return;

    async function fetchGraph() {
      try {
        const res = await fetch("/lex/memory/recollection-graph");
        if (res.ok) {
          const json = await res.json();
          setData(json);
        }
      } catch (err) {
        console.error("Failed to fetch recollection graph:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchGraph();
  }, [isEnabled]);

  const handleIframeLoad = () => {
    if (iframeRef.current && iframeRef.current.contentWindow && data) {
      iframeRef.current.contentWindow.postMessage(
        { type: "APP_GRAPH_PAYLOAD", payload: data },
        "*"
      );
    }
  };

  if (!isEnabled || loading) {
    return null;
  }

  // Fallback empty state if fetch failed completely
  if (!data) {
    return (
      <Box p={4} borderWidth="1px" borderColor={borderColor} borderRadius="xl" bg={cardBg} shadow="sm" maxW="sm">
        <Text fontSize="sm" color="gray.500" fontStyle="italic">
          Nothing strong came to mind
        </Text>
        <Text fontSize="md">
          I don’t have a strong remembered connection to show here yet.
        </Text>
      </Box>
    );
  }

  return (
    <Box p={4} borderWidth="1px" borderColor={borderColor} borderRadius="xl" bg={cardBg} shadow="sm" maxW="lg" h="300px" position="relative" overflow="hidden">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        title="Recollection Graph"
        style={{ width: "100%", height: "100%", border: "none" }}
        onLoad={handleIframeLoad}
      />
    </Box>
  );
}

export default RecollectionGraphFrame;
